import { render, staticRenderFns } from "./GProfile.vue?vue&type=template&id=07d1b0dd&"
import script from "./GProfile.vue?vue&type=script&lang=js&"
export * from "./GProfile.vue?vue&type=script&lang=js&"
import style0 from "./GProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports